import { useState } from 'react';

type Props<T extends string | number> = {
  titulo: string;
  opcoes: ReadonlyArray<{ value: T; label: string }>;
  selecionados: T[];
  onChange: (valores: T[]) => void;
};

export default function FidcSelecaoDupla<T extends string | number>({ titulo, opcoes, selecionados, onChange }: Props<T>) {
  const [marcadosDisponiveis, setMarcadosDisponiveis] = useState<string[]>([]);
  const [marcadosSelecionados, setMarcadosSelecionados] = useState<string[]>([]);
  const disponiveis = opcoes.filter(o => !selecionados.includes(o.value));
  const adicionar = (todos: boolean) => {
    onChange([...selecionados, ...disponiveis.filter(o => todos || marcadosDisponiveis.includes(String(o.value))).map(o => o.value)]);
    setMarcadosDisponiveis([]);
  };
  const remover = (todos: boolean) => {
    onChange(todos ? [] : selecionados.filter(v => !marcadosSelecionados.includes(String(v))));
    setMarcadosSelecionados([]);
  };
  return <div className="mb-3" role="group" aria-label={titulo}>
    <div style={{ display: 'flex', alignItems: 'stretch' }}>
      <label style={{ flex: 1, minWidth: 0 }}>{titulo} Disponíveis *
        <select multiple aria-label={`${titulo} disponíveis`} value={marcadosDisponiveis}
          onChange={e => setMarcadosDisponiveis(Array.from(e.target.selectedOptions, o => o.value))}
          style={{ display: 'block', width: '100%', height: '200px' }}>
          {disponiveis.map(o => <option key={o.value} value={String(o.value)}>{o.label}</option>)}
        </select>
      </label>
      <div style={{ display: 'flex', flexDirection: 'column', justifyContent: 'center' }}>
        <button type="button" style={{ margin: '5px' }} title="Adicionar selecionados" disabled={!disponiveis.some(o => marcadosDisponiveis.includes(String(o.value)))} onClick={() => adicionar(false)}>{'>'}</button>
        <button type="button" style={{ margin: '5px' }} title="Adicionar todos" disabled={!disponiveis.length} onClick={() => adicionar(true)}>{'>>'}</button>
        <button type="button" style={{ margin: '5px' }} title="Remover selecionados" disabled={!selecionados.some(v => marcadosSelecionados.includes(String(v)))} onClick={() => remover(false)}>{'<'}</button>
        <button type="button" style={{ margin: '5px' }} title="Remover todos" disabled={!selecionados.length} onClick={() => remover(true)}>{'<<'}</button>
      </div>
      <label style={{ flex: 1, minWidth: 0 }}>Selecionados
        <select multiple aria-label={`${titulo} selecionados`} value={marcadosSelecionados}
          onChange={e => setMarcadosSelecionados(Array.from(e.target.selectedOptions, o => o.value))}
          style={{ display: 'block', width: '100%', height: '200px' }}>
          {selecionados.map(v => <option key={v} value={String(v)}>{opcoes.find(o => o.value === v)?.label || String(v)}</option>)}
        </select>
      </label>
    </div>
  </div>;
}
